export default __webpack_public_path__ + "static/media/Mani-Poses-15.00852b8e.png";